import http from '@utils/http';

// 获取验证码
export function apiGetVerifyCode(mobile) {
  const headers = {
    accept: 'application/json',
    'Content-Type': 'application/json',
  };
  return http
    .post(
      '/phoenix/phoenix/arctic/v1/user/verify',
      JSON.stringify({ mobile, msgType: 3 }),
      headers
    )
    .then(res => {
      if (res.status === 200) {
        return res.data;
      } else {
        throw res;
      }
    });
}

// 校验验证码
export function apiGetVerifyValid(params) {
  return http
    .post('/phoenix/phoenix/arctic/v1/user/VerifyValid', params)
    .then(res => {
      return res;
    });
}
// 根据批次号查询发票信息
export function apiGetBillList(params) {
  if (params.sourceType == 1) {
    return http
      .get('/workscene/workscene/v1/invoice/view/bySignBatchNo', params)
      .then(res => {
        if (res.status === 200) {
          return res.data;
        } else {
          throw res;
        }
      });
  } else {
    return http
      .get('/workscene/workscene/v1/invoiceCloud/view/bySignBatchNo', params)
      .then(res => {
        if (res.status === 200) {
          if (res.data.items.length) {
            res.data.items = res.data.items.map(item => {
              return {
                ...item,
                buyerBrandName: item.buyName,
                invoicedMoney: item.invoicingAmount,
                invoicedCode:item.invoiceCode,
                invoicedSid:item.invoiceNumber,
                createDate: item.invoicingDate,
              };
            });
          }
          return res.data;
        } else {
          throw res;
        }
      });
  }
}

// 根据批次号查询发票信息
export function apiBillSign(params) {
  return http
    .post('/workscene/workscene/v1/invoiceCloud/invoice/sign', params)
    .then(res => {
      if (res.status === 200) {
        return res.data;
      } else {
        throw res;
      }
    });
}
